import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Typography from "@mui/material/Typography";
export default function TicketNotesColumn({ notes }) {
    return _jsx(Fragment, { children: notes && _jsx(Typography, { children: notes.substring(0, 75) }) });
}
